var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('Toolbar',{attrs:{"toolbarTitle":_vm.computedTitle}}),_c('Activities',{attrs:{"isAdmin":true,"isCourseManagerValue":_vm.isCourseManagerValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }